'use client'

import { useGSAP } from '@gsap/react'
import { Breakpoint } from 'enums/Breakpoints.enum'
import gsap from 'gsap'
import { useRef } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkDirective from 'remark-directive'
import SplitType from 'split-type'
import styles from './AnimatedHeading.module.scss'
import { iconRemarkPlugin, spanRemarkPlugin } from './remarkPlugins'

type AnimatedHeadingProps = {
  title: string
  page: string
}

const AnimatedHeading = ({ title, page }: AnimatedHeadingProps) => {
  const container = useRef<HTMLHeadingElement>(null)

  useGSAP(
    () => {
      SplitType.create('h1', { types: 'words' })
      if (window.innerWidth > Breakpoint.TABLET_PORTRAIT) {
        gsap.from(container.current!.children, {
          opacity: 0,
          y: 100,
          duration: 0.8,
          stagger: 0.05,
        })
      }
    },
    { scope: container }
  )

  return (
    <ReactMarkdown
      remarkPlugins={[remarkDirective, iconRemarkPlugin, spanRemarkPlugin, remarkBreaks]}
      components={{
        /* @ts-expect-error: 'icon' is a custom component not defined in Components */
        icon: (props) => {
          return <div className={styles.icon + ' ' + styles[props.className]} />
        },
        h1: (props) => {
          return (
            <h1 ref={container} className={styles.header + ' ' + styles[page]}>
              {props.children}
            </h1>
          )
        },
      }}
    >
      {title}
    </ReactMarkdown>
  )
}

export default AnimatedHeading
